<template>
  <div class="mt-12 pb-12">
    <el-dialog title="" :visible.sync="isShowDetailsAddons" width="50%">
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Add-ons Details
        </h3></template
      >

      <AddonsDetails />
    </el-dialog>

    <h2 class="text-565656 fsize16 font-semibold border-b pb-4">Buy Add-ons</h2>
    <div class="mt-6 pr-4">
      <div
        class="flex items-center mb-6 cursor-pointer"
        v-for="(item, index) in addOns"
        :key="'item-' + index"
      >
        <div class="flex gap-6 w-10/12">
          <img
            :src="showImage(item.images)"
            class="object-contain wh-75px rounded-10px p-3 bg-cas"
            alt="banh"
          />

          <div class="w-full">
            <h3 class="col-4f text-xl mb-0 font-semibold flex items-center">
              {{ item.name }}
              <div
                v-if="item.name === 'Storage'"
                v-tooltip.top="{
                  content:
                    'Securely with cloud-based storage solutions available on the platform.',
                  class: 'toolcust',
                }"
              >
                <feather-icon
                  icon="InfoIcon"
                  class="ml-1 text-grey flex"
                  svgClasses="w-5 h-5"
                />
              </div>

              <div
                v-if="item.name === 'Whatsapp Credits'"
                v-tooltip.top="{
                  content:
                    'With your audience using this popular messaging platform.',
                  class: 'toolcust',
                }"
              >
                <feather-icon
                  icon="InfoIcon"
                  class="ml-1 text-grey flex"
                  svgClasses="w-5 h-5"
                />
              </div>

              <div
                v-if="item.name === 'Voice Blast'"
                v-tooltip.top="{
                  content: 'Audience, promoting your products or services.',
                  class: 'toolcust',
                }"
              >
                <feather-icon
                  icon="InfoIcon"
                  class="ml-1 text-grey flex"
                  svgClasses="w-5 h-5"
                />
              </div>

              <div
                v-if="item.name === 'Email Accounts'"
                v-tooltip.top="{
                  content:
                    'Acquired from Google and other sources to build your mailing lists on the platform.',
                  class: 'toolcust',
                }"
              >
                <feather-icon
                  icon="InfoIcon"
                  class="ml-1 text-grey flex"
                  svgClasses="w-5 h-5"
                />
              </div>

              <div
                v-if="item.name === 'Promotional/Transactional Emails'"
                v-tooltip.top="{
                  content: 'Reaching them effectively through the platform.',
                  class: 'toolcust',
                }"
              >
                <feather-icon
                  icon="InfoIcon"
                  class="ml-1 text-grey flex"
                  svgClasses="w-5 h-5"
                />
              </div>

              <div
                v-if="item.name === 'Transactional SMS'"
                v-tooltip.top="{
                  content:
                    'SMS credits available on the platform,ensuring efficient communication.',
                  class: 'toolcust',
                }"
              >
                <feather-icon
                  icon="InfoIcon"
                  class="ml-1 text-grey flex"
                  svgClasses="w-5 h-5"
                />
              </div>

              <div
                v-if="item.name === 'Live Stream'"
                v-tooltip.top="{
                  content:
                    'Using live stream credits on the platform, engaging viewers in real-time.',
                  class: 'toolcust',
                }"
              >
                <feather-icon
                  icon="InfoIcon"
                  class="ml-1 text-grey flex"
                  svgClasses="w-5 h-5"
                />
              </div>

              <div
                v-if="item.name === 'Custom Push Notifications'"
                v-tooltip.top="{
                  content: 'Them informed and connected through the platform.',
                  class: 'toolcust',
                }"
              >
                <feather-icon
                  icon="InfoIcon"
                  class="ml-1 text-grey flex"
                  svgClasses="w-5 h-5"
                />
              </div>
            </h3>
            <p
              class="font-mediu pt-2 fsize12 text-8f8f8f flex items-center"
              :class="[item.booster > 0 ? 'text-success' : 'col-4f']"
            >
              {{ item.currencyName }}
              {{ item.booster > 0 ? item.price * item.booster : item.price }} /
              {{
                item.booster > 0 ? item.quantity * item.booster : item.quantity
              }}
              {{ item.unit }}
            </p>

            <!-- <p
              @click="isShowDetailsAddons = true"
              class="pt-2 fsize12 text-primary font-semibold text-underline cursor-pointer"
            >
              View Details
            </p> -->
          </div>
        </div>
        <div class="w-2/12 flex justify-end cursor-pointer">
          <el-input-number
            size="small"
            type="phone"
            v-model="item.booster"
            @change="handleChange(item)"
            :min="0"
            :max="10"
          ></el-input-number>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import addOnsMaster from "@/Apicall/masters/addons.js";
import moment from "moment";
import AddonsDetails from "./AddonsDetailSummary";
export default {
  props: {
    dataGet: { type: Boolean, default: false },
    // addOnType: { type: String },
  },
  data() {
    return {
      addOns: [],
      selectedAddOns: [],
      num: 1,
      isShowDetailsAddons: false,
      booster: 0,
      currencySymbol: "",
      gstNumber: 0,
    };
  },
  components: {
    AddonsDetails,
  },
  mounted() {
    this.getAddOns();
  },
  computed: {
    ...mapState("user", ["selectedProject"]),
    ...mapState("admin", ["selectedPlan"]),
    ...mapState("projectFile", ["addOnType"]),
  },
  watch: {
    dataGet(value) {
      if (value) {
        for (let i = 0; i < this.addOns.length; i++) {
          for (let j = 0; j < this.selectedAddOns.length; j++) {
            if (this.addOns[i]._id === this.selectedAddOns[j].id) {
              console.log(this.addOns[i].booster);
              this.addOns[i].booster = 0;
            }
          }
        }
        this.selectedAddOns = [];
      }
    },
  },

  methods: {
    async test(price) {
      let renewalDate = new Date(this.selectedPlan[0].renewalDate);
      let currentDate = new Date();
      let DiffDays = Math.ceil((renewalDate - currentDate) / 86400000);

      let diffPercentDate = (price * DiffDays) / 365;

      if (renewalDate != "Invalid Date") {
        let DiffDays = Math.ceil((renewalDate - currentDate) / 86400000);
        diffPercentDate = (price * DiffDays) / 365;
      } else {
        diffPercentDate = price;
      }
      return diffPercentDate;
    },
    async handleChange(item) {
      if (item.booster !== undefined) {
        let renewalDate = new Date(this.selectedPlan[0].renewalDate);
        let currentDate = new Date();
        let DiffDays = Math.ceil((renewalDate - currentDate) / 86400000);
        if (item.addOnType == "Renewable") {
          var deductedPrice = await this.test(item.price);
        } else {
          var deductedPrice = item.price;
        }
        const addOn = {
          id: item._id,
          name: item.name,
          quantity: item.quantity,
          booster: item.booster,
          payment_status: "Paid",
          purchased_on: moment().format("YYYY-MM-DD"),
          price: item.price,
          calculatedPrice: deductedPrice * item.booster,
          pricePermonth: (item.price / 12).toFixed(2),
          daysRemain: DiffDays,
          deductedPrice: deductedPrice,
          currency: item.currency,
        };
        // console.log(addOn, "addonssss");
        const index = this.selectedAddOns.findIndex((x) => x.id === addOn.id);
        console.log(index, "Yooo Anish");
        if (index > -1) {
          console.log(index, "xsxsxs");
          this.selectedAddOns[index].booster = addOn.booster;
          this.selectedAddOns[index].price = addOn.booster * addOn.price;
          this.selectedAddOns[index].quantity = addOn.booster * addOn.quantity;
          this.selectedAddOns[index].calculatedPrice =
            deductedPrice * item.booster;
        } else {
          this.selectedAddOns.push(addOn);
        }

        if (addOn.booster == 0) {
          this.selectedAddOns.splice(index, 1);
        }
        this.$emit("setAddOns", this.selectedAddOns);
      } else {
      }
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      return value
        ? `${process.env.VUE_APP_IMAGE_URL}/${value}`
        : default_image;
    },
    async getAddOns() {
      const { data } = await this.$store.dispatch("projectFile/getAddOns", {
        projectName: process.env.VUE_APP_PROJECT_NAME,
      });
      console.log(data, "ADD");
      // this.addOns = data.map((x) => {
      //   if (x.addOnType === this.addOnType) {
      //     return {
      //       ...x,
      //       booster: 0,
      //     };
      //   }
      // });

      this.addOns = data
        .filter((x) => x.addOnType === this.addOnType)
        .map((y) => {
          return { ...y, booster: 0 };
        });
      this.currencySymbol = data[0].currency;
      this.gstNumber = data[0].gstNumber;
      this.$emit("gstNumber", this.gstNumber);
      this.$emit("getCurrencySymbol", this.currencySymbol);
    },
  },
};
</script>
